import {
  useAPIQuery,
  UserAccountApi,
} from "melco-shared-logic";

export const useMachineLicensesOverview = (
) => {
 

  const query = useAPIQuery(
    UserAccountApi,
    ["machineLicensesOverview"],
    async (api) => {
      const response = await api.accountGetMachineLicenseSummary();

      

      return response
    },
    
  );

 // const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
   
   // errorComponent,
    ...query,
  };
};
